import { getFindClinicModalConfig } from '../../cdsConfigs/findClinicModalConfig';
import { EMAIL_REGEX } from '../../constants/constants';

export const getConfig = (
  handleSearchClinic,
  handleSelectClinic,
  handleRemoveClinic,
  handleNameClick,
  setShow,
  userCountry,
  dateInputFormat,
  labels,
) => {
  const clinicSelectorConfig = getFindClinicModalConfig(
    userCountry,
    labels,
  );

  clinicSelectorConfig.countryField.disabled = false;
  clinicSelectorConfig.searchButton.onClick = handleSearchClinic;
  clinicSelectorConfig.tableConfig.events.onRowClick =
    handleSelectClinic;
  clinicSelectorConfig.clinicField.minLength = 3;
  clinicSelectorConfig.results.maxCount = 20;

  return {
    formats: {
      date: dateInputFormat,
    },
    fields: [
      {
        id: 'firstName',
        validators: [
          {
            type: 'min',
            value: 1,
            message:
              'labels.advancedSearch.tabs.patient.errors.firstName.required',
          },
          {
            type: 'max',
            value: 40,
            message:
              'labels.createPatient.validation.firstName.invalidMaxLength',
          },
          {
            type: 'required',
            message:
              'labels.advancedSearch.tabs.patient.errors.firstName.required',
          },
          {
            type: 'matches',
            value: /^[^<>()"!%{}/\\0-9]*$/,
            message:
              'labels.createPatient.validation.firstName.noSpecialCharacters',
          },
        ],
      },
      {
        id: 'middleName',
        validators: [
          {
            type: 'max',
            value: 40,
            message:
              'labels.createPatient.validation.middleName.invalidMaxLength',
          },
          {
            type: 'matches',
            value: /^[^<>()"!%{}/\\0-9]*$/,
            message:
              'labels.createPatient.validation.middleName.noSpecialCharacters',
          },
        ],
      },
      {
        id: 'lastName',
        validators: [
          {
            type: 'min',
            value: 1,
            message:
              'labels.advancedSearch.tabs.patient.errors.lastName.required',
          },
          {
            type: 'max',
            value: 80,
            message:
              'labels.createPatient.validation.lastName.invalidMaxLength',
          },
          {
            type: 'required',
            message:
              'labels.advancedSearch.tabs.patient.errors.lastName.required',
          },
          {
            type: 'matches',
            value: /^[^<>()"!%{}/\\0-9]*$/,
            message:
              'labels.createPatient.validation.lastName.noSpecialCharacters',
          },
        ],
      },
      {
        id: 'dateOfBirth',
        fieldLabels: {
          d: 'labels.advancedSearch.tabs.patient.fields.dateOfBirth.dayLabel',
          m: 'labels.advancedSearch.tabs.patient.fields.dateOfBirth.monthLabel',
          y: 'labels.advancedSearch.tabs.patient.fields.dateOfBirth.yearLabel',
        },
        validators: [
          {
            type: 'required',
            message:
              'labels.advancedSearch.tabs.patient.fields.dateOfBirth.validators.required',
          },
        ],
      },
      {
        id: 'email',
        validators: [
          {
            type: 'matches',
            value: EMAIL_REGEX,
            message:
              'labels.advancedSearch.tabs.patient.errors.accountUsername.validEmail',
          },
          {
            type: 'required',
            message:
              'labels.advancedSearch.tabs.patient.errors.accountUsername.required',
          },
          {
            type: 'max',
            value: 55,
            message:
              'labels.advancedSearch.tabs.patient.errors.accountUsername.validEmail',
          },
        ],
      },
    ],
    clinicSelectorConfig,
    selectedClinicTable: {
      highlight: false,
      columns: [
        {
          display:
            'labels.findClinicModal.clinicsTable.columnHeaders.name',
          field: 'name',
          format: {
            type: 'string',
          },
          sortable: false,
        },
        {
          default: 'asc',
          display:
            'labels.findClinicModal.clinicsTable.columnHeaders.address',
          field: 'address',
          format: {
            type: 'string',
          },
          sortable: false,
          syncSort: 'orderNumberOrderDate',
        },
        {
          display: '',
          field: 'id',
          format: {
            additionalConfig: {
              className: 'remove',
              conditional: 'isRemovable',
              onClick: () => setShow(true),
              text: 'labels.findClinicModal.edit',
              visible: undefined,
            },
            type: 'button',
          },
          sortable: false,
        },
        {
          display: '',
          field: 'id',
          format: {
            additionalConfig: {
              className: 'remove',
              conditional: 'isRemovable',
              onClick: handleRemoveClinic,
              text: 'labels.findClinicModal.remove',
              visible: undefined,
            },
            type: 'button',
          },
          sortable: false,
        },
      ],
      formats: {
        currency: 'USD',
        date: 'mmm dd yyyy',
      },
      handleSortDataChange: function noRefCheck() {},
      loading: false,
      setLoading: function noRefCheck() {},
      setShow: function noRefCheck() {},
      show: false,
    },
    matchingPatientsTable: {
      highlight: false,
      hover: true,
      columns: [
        {
          display: 'labels.common.name',
          field: 'name',
          format: {
            collapsed: {
              type: 'composite',
              template:
                '<div><span class="ccl__text ccl__text--interactive-text">{{name}}</span></div><em></em></div>',
            },
            expanded: {
              type: 'emptycell',
            },
            onClick: () => {},
          },
          sortable: false,
        },
        {
          default: 'asc',
          display: 'labels.common.cochlearId',
          field: 'cochlearId',
          format: {
            type: 'string',
          },
          sortable: false,
          syncSort: 'orderNumberOrderDate',
        },
        {
          default: 'asc',
          display: 'labels.common.dateOfBirth',
          field: 'dobFormatted',
          format: {
            type: 'string',
          },
          sortable: false,
          syncSort: 'orderNumberOrderDate',
        },
        {
          display: 'labels.common.contactEmail',
          field: 'email',
          format: {
            type: 'string',
          },
          sortable: false,
        },
      ],
      formats: {
        currency: 'USD',
        date: 'mmm dd yyyy',
      },
      handleSortDataChange: function noRefCheck() {},
      loading: false,
      setLoading: function noRefCheck() {},
      setShow: function noRefCheck() {},
      show: false,
      clickableRow: true,
      events: {
        onLoadMore: () => {},
        onRowClick: (actions, row) => {
          handleNameClick(row.data);
        },
        onSort: () => {},
      },
    },
  };
};
